/* eslint-disable no-console */

/* eslint-disable @typescript-eslint/no-explicit-any */
import { AppError } from "shared/types/error/AppError"
import { RequestError } from "shared/types/error/RequestError"

import Honeybadger from "@honeybadger-io/js"

export class Logger {
  private static isDev = process.env.NODE_ENV === "development"

  static log(...args: any[]) {
    if (Logger.isDev) console.log(...args)
  }

  static warn(
    error: string | Error,
    message: string,
    context: Record<string, any> = {}
  ) {
    if (Logger.isDev) {
      console.warn(error, message, context)
    } else if (error instanceof RequestError) {
      error.notify()
    } else {
      Honeybadger.notify(error, {
        message,
        context
      })
    }
  }

  static error(
    error: string | Error | unknown,
    message?: string,
    context: Record<string, any> = {}
  ) {
    if (Logger.isDev) {
      console.error(error, message, context)
    } else if (error instanceof AppError) {
      error.notify()
    } else if (typeof error === "string" || error instanceof Error) {
      // An explicit `message: undefined` would overwrite the error's own message
      Honeybadger.notify(
        error,
        message === undefined ? { context } : { message, context }
      )
    } else {
      Honeybadger.notify("Unknown Error")
    }
  }
}
